import React from 'react'

export const AdFacebookCreateContext = React.createContext()

export const defaultAdFacebookCreateContext = {
  preselectedValues: {},
  campaignObjective: '',
  lineItemObjective: '',
  lineItem: {}
}

export const AdFacebookCreateContextProvider = ({
  children,
  preselectedValues = defaultAdFacebookCreateContext.preselectedValues,
  campaignObjective = defaultAdFacebookCreateContext.campaignObjective,
  lineItem = defaultAdFacebookCreateContext.lineItemObjective
}) => {
  return (
    <AdFacebookCreateContext.Provider
      value={{
        preselectedValues,
        campaignObjective,
        lineItem
      }}
    >
      {children}
    </AdFacebookCreateContext.Provider>
  )
}
